import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';

import { LoanNotesModel } from '../../cmg-1003/models/notes.model';
import { LoanNotesDataStore } from './loan-notes.store';
import { DirtyChecker2 } from '../core/dirty-checker-2';

@Injectable({ providedIn: 'root' })
export class LoanNotesQuery extends Query<LoanNotesModel> {
  protected store: LoanNotesDataStore;

  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);
  constructor() {
    const store = inject(LoanNotesDataStore);

    super(store);
    this.store = store;

    this.dirtyChecker2.dirtyChecker.setHead();
  }
}
